import React__default from 'react';
import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Divider } from '@sravni/react-design-system/lib/Divider';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';
import { Location } from '@sravni/react-icons';
import { useTheme, useStyles, useIsMobile } from '@sravni/react-utils';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import { defaultUserMenu } from '../../../mocks/defaultUserMenu.js';
import { DownloadApp } from '../../DownloadApp/src/DownloadApp.js';
import { LogoutButton } from '../../LogoutButton/src/LogoutButton.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import modules_eba0b2d9 from '../styles/UserMenu.module.less.js';

const UserMenu = (props) => {
    const { className, onRegionSelectClick, isDownloadAppEnabled = true, hasNotification, ...restProps } = props;
    const { settings = {}, currentRegion } = useCustomProps();
    const [theme] = useTheme();
    const cx = useStyles(modules_eba0b2d9);
    const isMobile = useIsMobile();
    const { pushAnalyticEvent } = useAnalyticEvents();
    const { userMenu = defaultUserMenu } = settings;
    const topGroup = userMenu.slice(0, -1);
    const bottomGroup = (userMenu || []).slice(-1);
    const bottomGroupLength = bottomGroup.length;
    const isDividerEnabled = Array.isArray(topGroup) && topGroup.length > 0;
    const handleLinkClick = React__default.useCallback((event) => {
        const label = event.currentTarget.dataset.label || '';
        pushAnalyticEvent("menuLinkClick" /* EVENTS.MENU_LINK_CLICK */, { eventLabel: `Профиль|${label}` });
    }, [pushAnalyticEvent]);
    const handleRegionSelectClick = React__default.useCallback(() => {
        onRegionSelectClick?.();
        pushAnalyticEvent("regionDialogClick" /* EVENTS.REGION_DIALOG_CLICK */, { eventLabel: `Вызов попапа` });
    }, [onRegionSelectClick, pushAnalyticEvent]);
    const getBottomIcon = (item, index) => {
        if (!item.icon)
            return;
        const isLastItem = index + 1 === bottomGroupLength;
        if (isLastItem && hasNotification) {
            return (React__default.createElement(Badge, { variant: "primary", color: "red", placement: "bottom-end" },
                React__default.createElement(Icon, { size: 20, icon: React__default.createElement("img", { src: item.icon, className: cx({ dark: theme === 'guinness' }), alt: "" }) })));
        }
        return React__default.createElement(Icon, { size: 20, icon: React__default.createElement("img", { src: item.icon, className: cx({ dark: theme === 'guinness' }), alt: "" }) });
    };
    return (React__default.createElement("div", { className: cx('menu', className), ...restProps },
        topGroup.map((item) => (React__default.createElement(Link, { "data-label": item.text, color: "dark", key: item.href, href: item.href, onClick: handleLinkClick, className: cx('item') },
            item.icon ? (React__default.createElement(Icon, { size: 20, icon: React__default.createElement("img", { src: item.icon, alt: "", className: cx({ dark: theme === 'guinness' }) }) })) : null,
            React__default.createElement(Text, { size: 16, strong: true }, item.text)))),
        isDividerEnabled ? React__default.createElement(Divider, { className: cx('divider') }) : null,
        isDownloadAppEnabled ? React__default.createElement(DownloadApp, { isMobile: isMobile }) : null,
        React__default.createElement(Link, { color: "dark", onClick: handleRegionSelectClick, className: cx('item') },
            React__default.createElement(Icon, { icon: React__default.createElement(Location, null) }),
            React__default.createElement(Space, { direction: "vertical" },
                React__default.createElement(Text, { size: 12, className: "h-color-D30" }, "\u041C\u043E\u0439 \u0433\u043E\u0440\u043E\u0434"),
                React__default.createElement(Text, { size: 16, strong: true }, currentRegion?.name ? currentRegion.name : 'Выберите город'))),
        bottomGroup.map((item, i) => (React__default.createElement(Link, { "data-label": item.text, color: "dark", key: item.href, href: item.href, onClick: handleLinkClick, className: cx('item') },
            getBottomIcon(item, i),
            React__default.createElement(Text, { size: 16, strong: true }, item.text)))),
        React__default.createElement(Divider, { className: cx('divider') }),
        React__default.createElement(LogoutButton, { className: cx('item') })));
};
UserMenu.displayName = 'UserMenu';

export { UserMenu };
//# sourceMappingURL=UserMenu.js.map
